
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
  landscape?: boolean;
}

const VideoModal = ({ isOpen, onClose, videoUrl, landscape = false }: VideoModalProps) => {
  // Prevent clicks inside the modal from closing it
  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className={`relative w-full ${landscape ? "max-w-[60rem]" : "max-w-md"} bg-black rounded-lg overflow-hidden`}
            onClick={handleModalClick}
          >
            <button
              onClick={onClose}
              className="absolute top-2 right-2 z-10 p-2 rounded-full bg-black/70 text-white hover:bg-black/90 transition-colors"
            >
              <X size={20} />
            </button>

            <div className={landscape ? "aspect-[16/9] w-full" : "aspect-[9/16] w-full"}>
              <video
                src={videoUrl}
                className="w-full h-full"
                autoPlay
                controls
                playsInline
                preload="auto"
                title="Video"
              ></video>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VideoModal;
